









































































































































































































































import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import excel from 'exceljs';
import InformationIcon from 'mdi-vue/InformationOutline';
import { mapActions, mapState } from 'vuex';

import Checkbox from '@/components/Checkbox.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Modal from '@/components/Modal.vue';
import LayoutContent from '@/components/LayoutContent.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { DisbursementsResponse, Disbursements, Bank } from '@/libs/api.interfaces';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { AxiosError } from 'axios';
import { DateRange } from '@/components/DatePicker.vue';
import { ActionTypes, State } from '@/store/disbursement';

interface ReportParams {
  dateRequest: DateRange;
  dateDisburse: DateRange;
  referenceIds: SelectItem[];
  names: SelectItem[];
  emails: SelectItem[];
  banks: { label: string; value: string }[];
  bankAccountNames: SelectItem[];
  bankAccountNumbers: SelectItem[];
  amounts: SelectItem[];
  disbursementDescriptions: SelectItem[];
  note: string;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
    Checkbox,
    Modal,
    LayoutContent,
    InformationIcon,
  },
  methods: {
    format,
    ...mapActions({ getBalance: ActionTypes.GET_DISBURSEMENT_BALANCE }),
  },
})
export default class ReportTable extends Vue {
  loading = true;
  loadingSubmit = false;
  disbursements: Disbursements[] = [];

  getBalance!: () => void;
  showModal = false;
  isReject = false;
  selected: { [id: number]: Disbursements } = {};
  currentTime = dayjs();
  destinationBank: string[] = [];
  totalDisbursement = 0;
  feeTotal = 0;

  reason = '';

  mapReferenceID!: {};

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  format!: (val: number) => string;

  // eslint-disable-next-line class-methods-use-this
  openDetail(id: number) {
    window.open(`/auto-disbursement/upload-request/${id}`, '_blank');
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  async getDisbursment(params: ReportParams, isExport = false, page = 1) {
    try {
      if (!isExport) {
        this.loading = true;
      }

      const dateRequest = {
        startDate: params.dateRequest.startDate === null ? undefined
          : dayjs(params.dateRequest.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: params.dateRequest.endDate === null ? undefined
          : dayjs(params.dateRequest.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
      };

      const dateDisburse = {
        startDate: params.dateDisburse.startDate === null ? undefined
          : dayjs(params.dateDisburse.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: params.dateDisburse.endDate === null ? undefined
          : dayjs(params.dateDisburse.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
      };

      const referenceIds = params.referenceIds.length === 0 ? undefined
        : params.referenceIds.map((e) => e.value);
      const names = params.names.length === 0 ? undefined
        : params.names.map((e) => e.value);
      const emails = params.emails.length === 0 ? undefined
        : params.emails.map((e) => e.value);
      const banks = params.banks.length === 0 ? undefined
        : params.banks.map((e) => e.value);
      const bankAccountNames = params.bankAccountNames.length === 0 ? undefined
        : params.bankAccountNames.map((e) => e.value);
      const bankAccountNumbers = params.bankAccountNumbers.length === 0 ? undefined
        : params.bankAccountNumbers.map((e) => e.value);
      const amounts = params.amounts.length === 0 ? undefined
        : params.amounts.map((e) => e.value);
      const disbursementDescriptions = params.disbursementDescriptions.length === 0 ? undefined
        : params.disbursementDescriptions.map((e) => e.value);
      const disbursementNote = params.note === '' ? undefined : params.note;

      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.get<DisbursementsResponse>('/disbursement', {
        params: {
          page,
          request_start_date: dateRequest.startDate,
          request_end_date: dateRequest.endDate,
          disburse_start_date: dateDisburse.startDate,
          disburse_end_date: dateDisburse.endDate,
          reference_id: referenceIds,
          receiver_name: names,
          receiver_email: emails,
          bank_destination: banks,
          bank_account_name: bankAccountNames,
          bank_account_number: bankAccountNumbers,
          amount: amounts,
          description: disbursementDescriptions,
          note: disbursementNote,
          status: ['REQUESTED'],
          export: isExport ? true : undefined,
        },
      });
      /* eslint-enable @typescript-eslint/camelcase */

      if (isExport) {
        return data;
      }

      this.page = page;
      this.disbursements = data.data;
      this.totalPage = Math.ceil(data.total / data.per_page);
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.loading = false;

      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  async export(params: ReportParams) {
    showToast(ToastType.SUCCESS, 'Export Disbursement',
      'Export is starting, please wait! This may take a while');

    try {
      const workbook = this.createWorkbook();
      await this.processExportPage(params, workbook, 1);
    } catch (err) {
      console.log(err);
      showToast(ToastType.FAILED,
        `Error [${(err as AxiosError).response?.status}]`, 'Failed to export disbursement');
    }

    showToast(ToastType.SUCCESS, 'Export Disbursement', 'Export finished');
  }

  // eslint-disable-next-line class-methods-use-this
  createWorkbook() {
    const workbook = new excel.Workbook();
    workbook.created = dayjs().toDate();

    const sheet = workbook.addWorksheet('Report', { views: [{ state: 'frozen', ySplit: 1 }] });

    sheet.getRow(1).font = { bold: true };
    sheet.columns = [
      { header: 'Date & Time Request', width: 18 },
      { header: 'Date & Time Disburse', width: 18 },
      { header: 'Reference ID', width: 14 },
      { header: 'Receiver Name', width: 40 },
      { header: 'Receiver Email', width: 40 },
      { header: 'Receiver Destination Bank', width: 14 },
      { header: 'Receiver Bank Account Name', width: 40 },
      { header: 'Receiver Bank Account Number', width: 32 },
      { header: 'Final Disbursement Amount', width: 18 },
      { header: 'Description', width: 14 },
      { header: 'Status', width: 10 },
    ];

    return workbook;
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadSheet(workbook: excel.Workbook, part?: number) {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer]);

    const fileURL = window.URL.createObjectURL(blob);
    const fileLink = document.createElement('a');

    const filename = `disbursement request${part ? `.part${part}` : ''}.xlsx`;

    fileLink.href = fileURL;
    fileLink.setAttribute('download', filename);
    document.body.appendChild(fileLink);
    fileLink.click();
  }

  async processExportPage(params: ReportParams, workbook: excel.Workbook, page = 1, part = 1) {
    try {
      const {
        data,
        last_page: lastPage,
        to,
      } = await this.getDisbursment(params, true, page) as DisbursementsResponse;

      const sheet = workbook.getWorksheet(1);

      data.forEach((item) => {
        sheet.addRow([
          item.disbursement_request,
          item.disbursement_date,
          item.reference_id,
          item.receiver_name,
          item.receiver_email,
          item.bank_destination,
          item.bank_account_name,
          item.bank_account_number,
          item.amount,
          item.description,
          item.status,
        ]);
      });

      if ((to / (100000 * part)) >= 1) {
        await this.downloadSheet(workbook, part);
        const newWorkbook = await this.createWorkbook();
        await this.processExportPage(params, newWorkbook, page + 1, part + 1);
      } else if (page < lastPage) {
        await this.processExportPage(params, workbook, page + 1, part);
      } else if (part > 1) {
        await this.downloadSheet(workbook, part);
      } else {
        await this.downloadSheet(workbook);
      }
    } catch (err) {
      console.log(err);
      showToast(ToastType.FAILED, 'Error', 'Failed to export disbursement');
    }
  }

  selectRow(disbursement: Disbursements) {
    if (this.isSelected(disbursement.id)) {
      this.$delete(this.selected, disbursement.id);
    } else {
      this.$set(this.selected, disbursement.id, disbursement);
    }

    this.$emit('select-change', Object.keys(this.selected).length);
  }

  get isAllChecked() {
    return this.disbursements.every((e) => this.selected[e.id] !== undefined);
  }

  checkAll(checked: boolean) {
    if (checked) {
      this.disbursements.forEach((e) => {
        this.$set(this.selected, e.id, e);
      });
    } else {
      this.disbursements.forEach((e) => {
        this.$delete(this.selected, e.id);
      });
    }

    this.$emit('select-change', Object.keys(this.selected).length);
  }

  resetSelected() {
    this.disbursements.forEach((e) => {
      this.$delete(this.selected, e.id);
    });
  }

  async showPreview(reject: boolean) {
    // this.showModal = true;
    this.loadingSubmit = true;
    this.currentTime = dayjs();
    this.destinationBank = [];
    this.totalDisbursement = 0;
    const payloadFee: {
      /* eslint-disable @typescript-eslint/camelcase */
      // bank_destination: string;
      // amount: string;
      description: string;
      product: string;
      receiver_name: string;
      receiver_email: string;
      bank_destination: string;
      bank_account_name: string;
      bank_account_number: string;
      amount: any;
      note: string;
      reference_id: string;
    }[] = [];

    Object.entries(this.selected).forEach((e) => {
      // console.log(e);
      if (!this.destinationBank.includes(e[1].bank_destination)) {
        this.destinationBank.push(e[1].bank_destination);
      }
      this.totalDisbursement += e[1].amount;
      // bank_destination: e[1].bank_destination,
      // amount: e[1].amount.toString(),
      let amountInput = 0;
      if (e[1].type_fee === 'INCLUDE') {
        amountInput = e[1].amount + e[1].fee;
      } else {
        amountInput = e[1].amount;
      }

      payloadFee.push({
        description: e[1].description,
        product: e[1].product,
        receiver_name: e[1].receiver_name,
        receiver_email: e[1].receiver_email,
        bank_destination: e[1].bank_destination,
        bank_account_name: e[1].bank_account_name,
        bank_account_number: e[1].bank_account_number,
        amount: amountInput,
        note: e[1].note,
        reference_id: e[1].reference_id,
      });
    });
    // console.log(payloadFee);
    try {
      const swap: { [key: string]: number } = {};
      const { data } = await api.get<Bank[]>('/bank');
      Object.entries(data[0]).forEach((a: any, b) => {
        const [c, d] = a;
        swap[d] = c;
      });
      // bank_destination: swap[e.bank_destination],
      // amount: e.amount,
      const mapReferenceID: any[] = [];
      payloadFee.forEach((e: any) => {
        mapReferenceID.push(e.reference_id);
      });
      this.mapReferenceID = mapReferenceID;

      const mapped = payloadFee.map((e: any) => ({
        description: e.description,
        product: e.product,
        receiver_name: e.receiver_name,
        receiver_email: e.receiver_email,
        bank_destination: swap[e.bank_destination],
        bank_account_name: e.bank_account_name,
        bank_account_number: e.bank_account_number,
        amount: e.amount,
        note: e.note,
        reference_id: e.reference_id,
      }));
      // console.log(mapped);
      const response = await api.post<{
        data: {
          fee: number;
        }[];
      }>('/disbursement/transaction/fee', {
        data: mapped,
      });
      this.feeTotal = response.data.data.map((e: { fee: number }) => e.fee).reduce((a, v) => a + v);
      this.$emit('btnLoadingApproval');
    } catch (err) {
      console.error(err);
    }
    this.loadingSubmit = false;
    this.isReject = reject;
    this.showModal = true;
  }

  closePreview() {
    this.showModal = false;
    this.$emit('btnLoadingApproval');
  }

  async process() {
    this.loadingSubmit = true;

    const settlementIds = Object.keys(this.selected).map((e) => Number(e));

    try {
      await api.post(`/disbursement/${this.isReject ? 'reject' : 'approve'}`,
        {
          // eslint-disable-next-line @typescript-eslint/camelcase
          disbursement_id: settlementIds,
          reference_id: this.mapReferenceID,
          reason: this.isReject ? this.reason : undefined,
        });
      showToast(ToastType.SUCCESS, 'Congratulations',
        this.isReject
          ? 'Your disbursement rejection has been processed.'
          : 'Your disbursement approval has been processed.');
      this.getBalance();
      this.loadingSubmit = false;
      this.showModal = false;
      this.resetSelected();
      this.$emit('refresh');
      this.$emit('btnLoadingApproval');
      this.$router.push('/auto-disbursement/approval-request/approval');
    } catch (err) {
      this.$emit('refresh');
      this.$emit('btnLoadingApproval');
      this.loadingSubmit = false;
      console.error(err);
      const error = err as AxiosError;
      showToast(ToastType.FAILED, `Error ${error.response?.status}`,
        this.isReject
          ? 'Your disbursement request is failed. Please try again.'
          : 'Your disbursement request is failed. Please try again.');
      // 'Your disbursement rejection has been processed'
    }
  }

  isSelected(id: number) {
    return this.selected[id] !== undefined;
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }

  // eslint-disable-next-line class-methods-use-this
  get previewTime() {
    return dayjs().format('MMMM D, YYYY HH:mm:ss');
  }

  get previewBanks() {
    return this.destinationBank.sort().join(', ');
  }

  get previewTotalDeduction() {
    return this.totalDisbursement + this.feeTotal;
  }
}
